import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const bulkLoginStartSlice = createSlice({
  name: "bulkLoginStartReducer",
  initialState: { pageNo: 1, 
    pageSize: 10 ,
    searchParam: null, 
  },
  
  reducers: {
    setBulkLoginStartPageNo: (state, action: PayloadAction<number>) => {
      state.pageNo = action.payload;
    },
    setBulkLoginStartPageSize: (state, action: PayloadAction<number>) => {
      state.pageSize = action.payload;
    },
    setBulkLoginStartSearchParam: (state, action: PayloadAction<any>) => {
      state.searchParam = action.payload;
    },
    
 }
});

export const {   
    setBulkLoginStartPageNo,
    setBulkLoginStartPageSize,
    setBulkLoginStartSearchParam,  
   } = bulkLoginStartSlice.actions;
export default bulkLoginStartSlice.reducer;